module.exports = __webpack_public_path__ + "static/media/1.bdfae7a0.jpg";